import * as modal from "../util/modal.ts";
import ApiServer from "../ApiServer.js";
import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import * as contactManager from "./contact-manager.js";
import {ContactCache} from "./ContactCache.js";
import * as actionMenu from "../widget/action-menu-registry.ts"
import Icons from "../svg/Icons.ts"


actionMenu.register({
  contactmenu(){
    var contact = ContactCache.get(this.metaId());
    
    var menu = [];
    if(contact.editable){
      menu.push({onclick:'contactedit|'+contact.metaId,svg:Icons.ic_edit,i18nkey:'actions.edit'})
      menu.push({onclick:'contactdelete',svg:Icons.ic_delete,i18nkey:'actions.delete','color':'var(--red)'})
    }
    //commented because does not work need to share a file .vcf and it is refused by navigator
    //menu.push( {onclick:'contactshare',svg:Icons.ic_send,i18nkey:'actions.send'})
    menu.push( {onclick:'contactdownload',svg:Icons.ic_export,i18nkey:'actions.save'})
    
    return {menu}
  },
  async contactaddfield(){
    var 
      [TPL_INPUT_DEVICE,TPL_INPUT_ADDRESS,TPL_INPUT_FUNCTION,TPL_INPUT_BIRTHDATE] = await Promise.all([
        import("../contact/input_device.mustache"),
        import("../contact/input_address.mustache"),
        import("../contact/input_function.mustache"),
        import("../contact/input_birthdate.mustache")
      ]),
    
    
      form = this.get(0).form,
      devices = ['MOBILE','PHONE','EMAIL'].map(deviceType=>{
        var 
          index = form.index?form.index++:form.index=1000,
          device = new ApiServer.types.IDevice({deviceType:deviceType})
        device.index = index;
        return {i18nkey:device.label,clickFunction:()=>Html.setHtmlAtEnd($('#extrafields'),TPL_INPUT_DEVICE,device)}
      }),
      addresses = ['HOME','WORK'].map(placeType=>{
        var 
          index = form.index?form.index++:form.index=1000,
          address = new ApiServer.types.IAddress({placeType:placeType})
        address.index = index;
        return {i18nkey:address.label,clickFunction:()=>Html.setHtmlAtEnd($('#extrafields'),TPL_INPUT_ADDRESS,address)}
      }),
      functionMenu = form['function']?[]:[{i18nkey:'Type',clickFunction:()=>Html.setHtmlAtEnd($('#extrafields'),TPL_INPUT_FUNCTION)}],
      birthDateMenu = form.birthDate?[]:[{i18nkey:'labels.birthday',clickFunction:()=>Html.setHtmlAtEnd($('#extrafields'),TPL_INPUT_BIRTHDATE)}];
    
    return {
      menu:devices.concat(addresses).concat(functionMenu).concat(birthDateMenu)
    }
  }
})

Html.register({
  contactnew(){
    import("../contact/new_contact.mustache").then(function(NEW_CONTACT_TEMPLATE){
      modal.openModal(NEW_CONTACT_TEMPLATE,{devices:[
        new ApiServer.types.IDevice({deviceType:'MOBILE'}),
        new ApiServer.types.IDevice({deviceType:'EMAIL'})
        ]});
    });
  },
  contactedit(id){
    import("../contact/new_contact.mustache").then(function(EDIT_CONTACT_TEMPLATE){
      modal.openModal(EDIT_CONTACT_TEMPLATE,ContactCache.get(id));
    });
  },
  contactdelete(){
    var metaId = this.metaId();
    modal.confirmDelete('contactDetailsJs.deleteConfirm',function(){
      ApiServer.metadelete([metaId])
      amplify.publish('contactDeleted',{})
    })
  },
  contactshare(){
    contactManager.share(ContactCache.get(this.metaId()))
  },
  contactdownload(){
    contactManager.download(ContactCache.get(this.metaId()))
  }
},()=>ContactCache.need());

function onChange(){
  modal.closeModal()
}
amplify.subscribe("contactCreated",onChange);
amplify.subscribe("contactUpdated",onChange);